import React from "react";

export const BatteryCapacity: React.FC = () => {
    return (
        <img src={'/icon_battery_capacity.png'} alt={"Battery Capacity"} height={92} width={92} />
    );
};